var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import { useContext, createContext, useState, useEffect } from 'react';
import { fetchHelper } from '@lucidhq/lucidium';
import { REACT_APP_LAS_API_URL } from './env';
import { useAuth } from './hooks';
var defaultContext = {
    roles: [],
    scopes: [],
    isLoading: false,
    error: undefined
};
export var RoleContext = createContext(defaultContext);
export var RoleProvider = function (_a) {
    var children = _a.children, usesShortToken = _a.usesShortToken;
    var _b = useAuth(), getAccessToken = _b.getAccessToken, isAuthenticated = _b.isAuthenticated;
    var _c = __read(useState(false), 2), isLoading = _c[0], setIsLoading = _c[1];
    var _d = __read(useState(), 2), error = _d[0], setError = _d[1];
    var _e = __read(useState([]), 2), roles = _e[0], setRoles = _e[1];
    var _f = __read(useState([]), 2), scopes = _f[0], setScopes = _f[1];
    // Can't pass body and contentType to Lucidium useFetchEffect
    // so I reimplemented it
    useEffect(function () {
        if (!isAuthenticated)
            return;
        var makeCall = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, claims, scopes_1, permissions, roles_1, _a, response, error, roles, scopes, errorMessage;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        setIsLoading(true);
                        setError(undefined);
                        return [4 /*yield*/, getAccessToken()];
                    case 1:
                        accessToken = _e.sent();
                        if (!usesShortToken && accessToken) {
                            claims = JSON.parse(window.atob(accessToken.split('.')[1]));
                            scopes_1 = (_b = claims['http://lucid/scopes']) === null || _b === void 0 ? void 0 : _b.split(' ');
                            permissions = (_c = claims['http://lucid/permissions']) === null || _c === void 0 ? void 0 : _c.split(' ');
                            roles_1 = (_d = claims['http://lucid/roles']) === null || _d === void 0 ? void 0 : _d.split(' ');
                            setRoles(roles_1 || []);
                            setScopes(__spread(scopes_1, permissions) || []);
                            setIsLoading(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchHelper({
                                url: REACT_APP_LAS_API_URL + "/v1/authorization/exchange",
                                body: "token=" + accessToken,
                                contentType: 'application/x-www-form-urlencoded'
                            }, {})];
                    case 2:
                        _a = _e.sent(), response = _a.response, error = _a.error;
                        roles = (response === null || response === void 0 ? void 0 : response.roles) || [];
                        scopes = (response === null || response === void 0 ? void 0 : response.scopes) || [];
                        errorMessage = !!error
                            ? { message: 'Error while fetching roles' }
                            : undefined;
                        setRoles(roles);
                        setScopes(scopes);
                        setError(errorMessage);
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        makeCall();
    }, [isAuthenticated]);
    return (React.createElement(RoleContext.Provider, { value: { roles: roles, isLoading: isLoading, error: error, scopes: scopes } }, children));
};
export var useRoles = function () {
    var context = useContext(RoleContext);
    if (context === undefined) {
        throw new Error('useRoles must be used within a RoleProvider');
    }
    return context;
};
//# sourceMappingURL=RoleContext.js.map